import { isValidPhoneNumber } from "react-phone-number-input";
import { validate } from "email-validator";

export const validatePhoneNumber = (phoneNumber: string) => {
  const _phoneNumber = phoneNumber?.trim() || "";
  if (_phoneNumber === "") {
    return "phoneNumberIsRequired";
  } else if (!isValidPhoneNumber(_phoneNumber)) {
    return "invalidPhoneNumber";
  } else {
    return "";
  }
};

export const validatePassword = (password: string) => {
  // Check for minimum length
  if (password.length < 8) {
    return "passwordConstraintMinChars";
  } else {
    // Check for at least one numeric value
    const hasNumber = /\d/;
    if (!hasNumber.test(password)) {
      return "passwordConstraintNum";
    } else {
      // Check for at least one special character
      const specialChars = "+-/=~£{}!@#$%^&*(),.?";
      const hasSpecialChar = new RegExp(`[${specialChars}]`); // Create regex from string
      if (!hasSpecialChar.test(password)) {
        return "passwordConstraintSpecialChars";
      } else {
        // Check for at least one uppercase letter
        const hasUpperCase = /[A-Z]/;
        if (!hasUpperCase.test(password)) {
          return "passwordConstraintUpperCase";
        } else {
          // Check for at least one lowercase letter
          const lowerCasePattern = /[a-z]/;
          if (!lowerCasePattern.test(password)) {
            return "passwordConstraintLowerCase";
          } else {
            // If all checks pass, no error
            return "";
          }
        }
      }
    }
  }
};

export const validateConfirmPassword = (confirmPassword: string, password: string) => {
  if (confirmPassword !== password) {
    return "passwordDoNotMatch";
  }
  return "";
};

export const validateOldPassword = (oldPassword: string) => {
  if (!oldPassword) {
    return "oldPasswordIsRequired";
  }
  return "";
};

export const validateContactName = (name: string) => {
  return (
    validateRequiredField("nameIsRequired", name) || containsSpecialCharacters("invalidName", name)
  );
};

export const validateContactMessage = (message: string) => {
  return validateRequiredField("messageIsRequired", message);
};

export const validateFirstName = (firstName: string) => {
  return (
    validateRequiredField("firstNameIsRequired", firstName) ||
    containsSpecialCharacters("invalidFirstName", firstName)
  );
};

export const validateLastName = (lastName: string) => {
  return (
    validateRequiredField("lastNameIsRequired", lastName) ||
    containsSpecialCharacters("invalidLastName", lastName)
  );
};

export const validateEmail = (email: string, required: boolean = false) => {
  if (email.trim() && !validate(email)) {
    return "invalidEmail";
  } else if (required && !email.trim()) {
    return "emailIsRequired";
  } else {
    return "";
  }
};

const validateRequiredField = (translateKey: string, field: string) => {
  if (!field.trim()) {
    return translateKey;
  } else {
    return "";
  }
};

const containsSpecialCharacters = (translateKey: string, field: string): string => {
  const specialCharRegex = /[^a-zA-Z\u0600-\u06FF\s]/;
  if (specialCharRegex.test(field)) {
    return translateKey;
  }
  return "";
};
